import { render, staticRenderFns } from "./CellRendererSuggestionsActions.vue?vue&type=template&id=64935f7e"
import script from "./CellRendererSuggestionsActions.vue?vue&type=script&lang=js"
export * from "./CellRendererSuggestionsActions.vue?vue&type=script&lang=js"
import style0 from "./CellRendererSuggestionsActions.vue?vue&type=style&index=0&id=64935f7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports